var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"piece",class:{ white: _vm.white, black: _vm.black }})}
var staticRenderFns = []

export { render, staticRenderFns }